import { Container } from "semantic-ui-react";
import ProductList from "../Product/ProductList";
import ProductCard from "../Product/ProductCard";
import React, { useEffect, useState } from "react"
import _ from "lodash";
import shop from "shop/shop"

export default function LastProducts( { list } ) {
  const [products, setProducts] = useState( [] )
  useEffect( () => {
    shop.products.list( _.uniq( list ) )
      .then( products => {
        console.log( `ProductList::loaded`, products )
        setProducts( products )
      } )
  }, [list] )

  if ( products.length === 0 ) return null
  return <div className="LastProducts pv4 bg-silver">
    <Container>
      {/*Product Slider "last viewed"*/}
      <section className="section-product-slider pv5">
        <h2 className="mt2  ttu">{translate( "Zuletzt angesehen" )}</h2>
        <ProductList
          count={4}
          start={0}
          list={list}
          repeat={ProductCard}/>
      </section>
    </Container>
  </div>
}



// WEBPACK FOOTER //
// ./src/components/LastProducts/LastProducts.js